module.exports = __webpack_public_path__ + "static/media/college_icon.c60dbb75.png";